import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-view-icon',
  templateUrl: './view-icon.component.html',
  styleUrls: ['./view-icon.component.scss']
})
export class ViewIconComponent implements OnInit {
  @Input() item;

  constructor() { }
  getFlexClass(list) {
    // console.log(this.item)
    let klass = list.is_hidden ? 'flex-column-0' : list.flex_width;
    if (list.hasOwnProperty('background')) {
      klass += " " + list.background;
    }
    return klass;
  }

  ngOnInit() {
    //console.log(this.item)
  }

}
